export default "__VITE_ASSET__fqKmSJf7__"